<div id="basic-info" class="form-container">
  <div class="row">
    <div class="col-md-12 text-center">
      <h4 class="flex sm:justify-center text-3xl sm:text-40px sm:font-rhetorik-sans mt-6">Account Management</h4>
        <div *ngIf="errorMessage!=null" class="alert alert-danger">
        {{ errorMessage }}
      </div>
    </div>
  </div>
  <form #basicForm="ngForm">
    <div class="form-group">
      <br>
      <div> <!-- 1 -->
        <div> <!-- 2 -->
          <div class="form-repeat" *ngFor="let reqFrom of model.LoginRequestChangeFrom; let i = index; trackBy:listTrack">
            <div>
                <div class="col-md-6">
                    <label *ngIf="i == 0" class="flex sm:justify-left text-gray-tricon text-2xl sm:text-3xl my-2">Pending Login Change Requests From User</label>
                </div>
                <div class="col-md-6">
                  <input class="acct-mngmnt-input" type="text" matInput name="RequestEmailFrom[{{i}}]" id="RequestEmailFrom[{{i}}]" [attr.data-index]="i" readonly [(ngModel)]="reqFrom.RequestEmailFrom" #RequestEmailFrom="ngModel"/>
                  <div class="account-flex">
                      <button mat-flat-button color="accent" class="my-4 sm:text-base px-16" (click)="onAccept(reqFrom)">ACCEPT</button>
                      <button mat-flat-button color="accent" class="my-4 sm:text-base px-20" (click)="onDeny(reqFrom)">DENY</button>
                  </div>
                </div>
            </div>
        </div> <!-- /form-repeat -->
        <div *ngIf="!model.HasRequestFrom" class="md:flex md:items-baseline md:py-6">
            <div>
                <label class="flex sm:justify-left text-gray-tricon text-2xl sm:text-3xl my-2">Pending Login Change Requests From User</label>
            </div>
            <div class="md:pl-12">
              <span>No pending change requests to this user </span>
            </div>
          </div>
      </div> <!-- /2 -->
    </div> <!-- /1 -->
    <hr />
    </div>
    <div class="form-group">
      <div> <!-- 1 -->
        <div> <!-- 2 -->
          <div class="form-repeat" *ngFor="let reqTo of model.LoginRequestChangeTo; let i = index; trackBy:listTrack">
              <div class="row">
                  <div class="col-md-6 ">
                      <label *ngIf="i == 0" class="flex sm:justify-left text-gray-tricon text-2xl sm:text-3xl my-2">Pending Login Change Requests To User</label>
                  </div>
                  <div class="col-md-6">
                    <input class="acct-mngmnt-input" type="text" matInput name="RequestEmailTo[{{i}}]" id="RequestEmailTo[{{i}}]" [attr.data-index]="i" readonly [(ngModel)]="reqTo.RequestEmailTo" #RequestEmailTo="ngModel"/>
                    <div class="account-flex">
                        <button mat-flat-button color="accent" class="my-4 sm:text-base px-16"(click)="onCancel(reqTo)">CANCEL</button>
                    </div>
                  </div>
                </div>
        </div> <!-- /form-repeat -->
        <div *ngIf="!model.HasRequestTo" class="md:flex md:items-baseline md:py-6">
            <div>
                <label class="flex sm:justify-left text-gray-tricon text-2xl sm:text-3xl my-2">Pending Login Change Requests To User</label>
            </div>
            <div class="md:pl-20">
              <span>No pending change requests from this user </span>
            </div>
        </div>
      </div> <!-- /2 -->
    </div> <!-- /1 -->
    <hr />
    </div>
  </form>
</div>

<div class="dialog-modal__bg" [(hidden)]="!displaySuccessMsg" (onHide)="logOut()" (onClose)="logOut()" >
  <div class="dialog-modal__content">
    <div class="dialog-modal__titlebar"></div>
    <div class="dialog-modal__main">
      <p>Thank you for accepting the login credential change request.</p><br>
      <p>Please logout and login again to view transferred applications.</p><br>
      <p class="text-center">
        <button  mat-flat-button color="accent" class="my-4 sm:text-base px-20" (click)="logOut()">LOG OUT</button>
      </p>
    </div>
  </div>
</div>
